import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, DatePicker, Button, Row, Col, message, Select } from 'antd';
import axiosInstance from '../../services/axiosInstance';
import moment from 'moment';

const UnassignedPendingOrders = ({ handleClose }) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const handleFinish = async (values) => {
        setLoading(true);
        try {
            const from_date = values.dates[0].format('YYYY-MM-DD');
            const to_date = values.dates[1].format('YYYY-MM-DD');

            const params = {
                from_date,
                to_date,
            };


            const response = await axiosInstance.get('/task/v2/unassinged-order-sheet/', {
                params,
                responseType: 'blob'
            });


            if (response.status === 200) {
                // ✅ Handle file download
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'],
                });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${moment().format('DD-MM-YYYY hh:mm A')}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                message.success("Sheet Download Successfully")
                handleClose()

                return { success: true };
            } else {
                message.success("Something went wrong")
                setLoading(false);
            }
        } catch (err) {
            if (
                err?.response?.data instanceof Blob &&
                err?.response?.headers['content-type']?.includes('application/json')
            ) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorJson = JSON.parse(reader.result);
                        const errorMsg =
                            errorJson?.message ||
                            errorJson?.detail ||
                            'Something went wrong while downloading the sheet.';
                        message.error(errorMsg);
                    } catch (parseErr) {
                        message.error("An unknown error occurred.");
                    }
                };
                reader.readAsText(err.response.data);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleFinish}
        >
            <Row style={{ width: "100%" }}>
                <Col span={24}>
                    <Form.Item
                        label="Select Date Range"
                        name="dates"
                        rules={[{ required: true, message: 'Please select date range' }]}
                    >
                        <DatePicker.RangePicker style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
            </Row>
            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                    Submit
                </Button>
            </div>
        </Form>
    );
};

export default UnassignedPendingOrders;